import {createReducer, on} from '@ngrx/store';
import {datevWizardConfigDetailsStateInitial} from './datev-wizard-config-details.state.initial';
import {DatevWizardConfigDetailsActions} from './datev-wizard-config-details.actions';
import {ErrorEventEntitiesActions} from '../../../../../store/error-event-entities/error-event-entities.actions';


export const datevWizardConfigDetailsReducers = createReducer(
  datevWizardConfigDetailsStateInitial,

  on(
    DatevWizardConfigDetailsActions.connectToDatev,
    (state) => ({
      ...state,
      isConnecting: true,
      connectionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.connectToDatevSuccess,
    (state) => ({
      ...state,
      isConnecting: false,
      connectionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.connectToDatevFailure,
    (state, { error }) => ({
      ...state,
      isConnecting: false,
      connectionError: error,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.disconnectFromDatev,
    (state) => ({
      ...state,
      isDisconnecting: true,
      disconnectionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.disconnectFromDatevSuccess,
    (state) => ({
      ...state,
      isDisconnecting: false,
      disconnectionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.disconnectFromDatevFailure,
    (state, { error }) => ({
      ...state,
      isDisconnecting: false,
      disconnectionError: error,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.deleteConfiguration,
    (state) => ({
      ...state,
      isDeleting: true,
      deletionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.deleteConfigurationSuccess,
    (state) => ({
      ...state,
      isDeleting: false,
      deletionError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.deleteConfigurationFailure,
    (state, { error }) => ({
      ...state,
      isDeleting: false,
      deletionError: error,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.updateExportConfiguration,
    (state) => ({
      ...state,
      isUpdatingConfiguration: true,
      updateConfigurationError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.updateExportConfigurationSuccess,
    (state) => ({
      ...state,
      isUpdatingConfiguration: false,
      updateConfigurationError: undefined,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.updateExportConfigurationFailure,
    (state, { error }) => ({
      ...state,
      isUpdatingConfiguration: false,
      updateConfigurationError: error,
    }),
  ),

  on(
    DatevWizardConfigDetailsActions.setErrorEventsPageable,
    (state, { number, size }) => {
      if (!state.errorEventsPage) return state;
      return {
        ...state,
        errorEventsPage: {
          ...state.errorEventsPage,
          pageable: {
            ...state.errorEventsPage.pageable,
            number,
            size,
          },
        },
      };
    },
  ),

  // INFO: Speichere Page-State mit IDs beim erfolgreichen Laden
  on(
    ErrorEventEntitiesActions.loadErrorEventsSuccess,
    (state, { page }) => ({
      ...state,
      errorEventsPage: {
        content: page.content.map(job => job.id),
        pageable: page.pageable,
        totalElements: page.totalElements,
        elements: page.elements,
      },
    }),
  ),
);
